import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { CommonModule } from '@angular/common';

declare var _paq: any[];
@Component({
  selector: 'app-card-price',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-price.component.html',
  styleUrl: './card-price.component.scss',
})
export class CardPriceComponent {
  hovered = false;
  @Input() text: string = '';
  @Input() destacado: boolean = false;
  @Input() plan: string = '200';
  @Input() price: string = '52';
  whatsappLink: string = '';

  ngOnInit() {
    this.whatsappLink = `https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+estoy+interesado+en+el+Plan+${encodeURIComponent(
      this.plan
    )}&type=phone_number&app_absent=0`;
  }

  trackPlanSelection(): void {
    if (typeof _paq !== 'undefined') {
      const planValue = 'Plan ' + this.plan;
      console.log('Matomo: Rastreando selección de plan:', this.plan);
      _paq.push(['setCustomDimension', 4, 'Plan ' + this.plan]);

      _paq.push([
        'trackEvent',
        'Planes',
        'Clic Lo Quiero',
        planValue,
        0,
        {
          customDimensions: {
            4: planValue,
          },
        },
      ]);
    }
  }
}
